import Vue from 'vue';
import { resolveElement } from '@jgile/laravel-vue/resources/js/util';
const triggerCollapsed = 'collapse-collapsed';
const triggerBase = 'collapse-collapse';

if (window.Bus === undefined) {
    window.Bus = new Vue();
}

export default {
    bind(el, binding, vnode) {
        Vue.nextTick(() => {
            let targets = resolveElement(binding.value);
            let visible = !!binding.modifiers.show;

            if (targets) {
                if (!el.classList.contains(triggerBase)) {
                    el.classList.add(triggerBase);
                }

                if (!visible) {
                    if (!el.classList.contains(triggerCollapsed)) {
                        el.classList.add(triggerCollapsed);
                    }
                }

                el.addEventListener('click', function () {
                    if (el.classList.contains(triggerCollapsed)) {
                        el.classList.remove(triggerCollapsed);
                        Bus.$emit('collapseExpand', binding.value);
                    } else {
                        el.classList.add(triggerCollapsed);
                        Bus.$emit('collapseCollapse', binding.value);
                    }
                });

                // targets
                targets.forEach((target) => {
                    target.setAttribute('data-collapse-display', el.style.display);

                    if (!visible) {
                        target.style.display = 'none';
                    }

                    Bus.$on('collapseExpand', (payload) => {
                        if (payload === binding.value) {
                            target.style.display = el.getAttribute('data-collapse-display');
                        }
                    });

                    Bus.$on('collapseCollapse', (payload) => {
                        if (payload === binding.value) {
                            target.style.display = 'none';
                        }
                    });
                });
            }
        });
    },
    unbind: function (el, binding, vnode) {
        Bus.$off('collapseExpand', () => {});
        Bus.$off('collapseCollapse', () => {});

        let targets = resolveElement(binding.expression);

        if (targets) {
            targets.forEach((target) => {
                target.removeEventListener('click');
            });
        }
    },
};
